import { isNumber } from 'lodash';
import { CoreAPI } from '../../core';
import { getEditorOperateState } from '../states/editor-operate-state';
import { getLayerOperateState } from '../states/layer-operate-state';
import { getActiveInfo } from '../tools/active-info';
import { getSelectedInfo } from '../tools/selected-info';
import { OperateBase } from './operate-base';

export class OperateData extends OperateBase {
    constructor(identity: string) {
        super(identity);
    }

    destroy() {
        getEditorOperateState(this.identity).destroy();
        getLayerOperateState(this.identity).destroy();
        super.destroy();
    }

    /** 获取是否禁用编辑器操作 */
    isDisableOperate() {
        return getEditorOperateState(this.identity).disableOperate;
    }
    /** 禁用编辑器操作 */
    disableOperate(delActiveLayer?: boolean) {
        getEditorOperateState(this.identity).setDisableOperate(true, delActiveLayer);
    }
    /** 启用编辑器操作 */
    enableOperate() {
        getEditorOperateState(this.identity).setDisableOperate(false);
    }

    /** 获取是否禁用图层选择 */
    isDisablePick() {
        return !!getEditorOperateState(this.identity).disablePick;
    }
    /** 禁用图层选择 */
    disablePick(delActiveLayer = true) {
        getEditorOperateState(this.identity).setDisablePick(true, delActiveLayer);
    }
    /** 启用图层选择 */
    enablePick() {
        getEditorOperateState(this.identity).setDisablePick(false);
    }

    /** 获取是否是基础操作 */
    isBaseOperate() {
        return getEditorOperateState(this.identity).isBaseOperate;
    }
    /** 设置是否是基础操作 */
    setIsBaseOperate(isBaseOperate: boolean) {
        getEditorOperateState(this.identity).setIsBaseOperate(isBaseOperate);
    }

    /** 获取是否正在执行鼠标框选 */
    isMouseSelect() {
        return getEditorOperateState(this.identity).isMouseSelect;
    }
    /** 设置是否正在执行鼠标框选 */
    setIsMouseSelect(isMouseSelect: boolean) {
        getEditorOperateState(this.identity).setIsMouseSelect(isMouseSelect);
    }

    /** 获取悬停信息 */
    getHoverId() {
        return getLayerOperateState(this.identity).hoverId;
    }
    /** 设置悬停信息 */
    setHoverId(hoverId: string) {
        getLayerOperateState(this.identity).setHoverId(hoverId);
    }
    /** 删除悬停信息 */
    delHoverId() {
        getLayerOperateState(this.identity).setHoverId('');
    }

    /** 获取是否禁用移动 */
    isDisableMove() {
        return getEditorOperateState(this.identity).disableMove;
    }
    /** 禁用移动 */
    disableMove() {
        getEditorOperateState(this.identity).setDisableMove(true);
    }
    /** 启用移动 */
    enableMove() {
        getEditorOperateState(this.identity).setDisableMove(false);
    }

    /** 获取是否禁用缩放 */
    isDisableScale() {
        return getEditorOperateState(this.identity).disableScale;
    }
    /** 禁用缩放 */
    disableScale() {
        getEditorOperateState(this.identity).setDisableScale(true);
    }
    /** 启用缩放 */
    enableScale() {
        getEditorOperateState(this.identity).setDisableScale(false);
    }

    /** 获取是否禁用旋转 */
    isDisableRotate() {
        return getEditorOperateState(this.identity).disableRotate;
    }
    /** 禁用旋转 */
    disableRotate() {
        getEditorOperateState(this.identity).setDisableRotate(true);
    }
    /** 启用旋转 */
    enableRotate() {
        getEditorOperateState(this.identity).setDisableRotate(false);
    }

    /** 获取是否禁用 Hover */
    isDisableHover() {
        return getEditorOperateState(this.identity).disableHover;
    }
    /** 禁用 Hover */
    disableHover() {
        getEditorOperateState(this.identity).setDisableHover(true);
    }
    /** 启用旋转 */
    enableHover() {
        getEditorOperateState(this.identity).setDisableHover(false);
    }

    /** 获取是否禁用尺寸调整 */
    isDisableResize() {
        return getEditorOperateState(this.identity).disableResize;
    }
    /** 设置是否禁用尺寸调整 */
    disableResize() {
        getEditorOperateState(this.identity).setDisableResize(true);
    }
    /** 启用尺寸调整 */
    enableResize() {
        getEditorOperateState(this.identity).setDisableResize(false);
    }

    /** 获取是否禁用激活 */
    isDisableActive() {
        return getEditorOperateState(this.identity).disableActive;
    }
    /** 禁用激活 */
    disableActive() {
        getEditorOperateState(this.identity).setDisableActive(true);
    }

    /** 启用激活 */
    enableActive() {
        getEditorOperateState(this.identity).setDisableActive(false);
    }

    /** 获取是否正在执行鼠标框选 */
    isDisableMouseSelect() {
        return getEditorOperateState(this.identity).disableMouseSelect;
    }
    /** 设置是否正在执行鼠标框选 */
    disableMouseSelect() {
        getEditorOperateState(this.identity).setDisableMouseSelect(true);
    }
    enableMouseSelect() {
        getEditorOperateState(this.identity).setDisableMouseSelect(false);
    }
    /** 尝试删除激活图层 */
    tryRemoveActiveLayer(originIndexOrDelLayerId: number | string) {
        const info = this.getActiveInfo();
        if (!info) return;
        const coreApi = CoreAPI(this.identity);
        if (isNumber(originIndexOrDelLayerId)) {
            const layerOriginIndex = coreApi.tryGetLayerOriginIndex(info.info.id);
            if (layerOriginIndex === originIndexOrDelLayerId) {
                this.delActiveLayer();
            }
        } else {
            const wrapLayer = coreApi.getWrapLayer(originIndexOrDelLayerId, true);
            if (info.info.id === wrapLayer?.id) {
                this.delActiveLayer();
            }
        }
    }
    /** 尝试刷新激活图层 */
    tryRefreshActiveLayer(layerId: string) {
        const activeInfo = this.getActiveInfo();
        if (activeInfo) {
            const wrapLayer = CoreAPI(this.identity).getWrapLayer(layerId, true);
            if (wrapLayer?.id === activeInfo.info.id) {
                if (CoreAPI(this.identity).checkIsExtraGroup(wrapLayer)) {
                    // this.delActiveLayer();
                    this.setActiveLayer(activeInfo.info.id, true);
                } else {
                    this.setActiveLayer(activeInfo.info.pickId || activeInfo.info.id, true);
                }
            } else {
                const activeId = activeInfo.info.pickId || activeInfo.info.id;
                if (activeId === layerId) {
                    this.setActiveLayer(activeId, true);
                }
            }
        }
    }
    /** 获取激活信息 */
    getActiveInfo() {
        const key = getLayerOperateState(this.identity).activeInfoKey;
        return getActiveInfo(this.identity, key);
    }
    /** 设置激活图层 */
    setActiveLayer(layerId: string, ignoreDisableOperate = false) {
        getLayerOperateState(this.identity).setActiveLayer(layerId, ignoreDisableOperate);
    }
    /** 删除激活图层 */
    delActiveLayer(autoRerender = true) {
        getLayerOperateState(this.identity).delActiveLayer(autoRerender);
    }
    /** 获取激活图层 */
    getActiveLayer() {
        return getLayerOperateState(this.identity).getActiveLayer();
    }
    /**
     * 获取激活图层的选中图层
     * 如果 force 为 true，没有选中图层时，会返回激活图层
     * @param force - 默认true
     */
    getActivePickLayer(force = true) {
        return getLayerOperateState(this.identity).getActivePickLayer(force);
    }
    /** 删除图层 */
    delLayer(layerId: string) {
        return getLayerOperateState(this.identity).delLayer(layerId);
    }

    /** 清除选中图层 */
    clearSelected() {
        getLayerOperateState(this.identity).clearSelected();
    }
    /** 设置选中图层 */
    setSelected(args: string[] | string) {
        getLayerOperateState(this.identity).setSelected(args);
    }
    /** 获取选中图层信息 */
    getSelectedInfo() {
        const key = getLayerOperateState(this.identity).selectedInfoKey;
        return getSelectedInfo(this.identity, key);
    }
}
